export enum EnumStatusUpload {
  START = 'Starting',
  UPLOADING = 'Uploading',
  PROCESSING = 'Processing',
  COMPLETE = 'Complete',
  FAILED = 'Failed',
}
